import * as React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
    createStyles({
        '@keyframes animatedItem': {
            from: { opacity: 0, transform: 'translateY(10px)' },
            to:   { opacity: 1, transform: 'translateY(0)' },
        },
        root: {
            animation: '$animatedItem 0.15s ease both',
        },
        fill: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            height: '100%',
            minHeight: 0,
        },
    })
);

interface AnimatedItemProps {
    delay?: number;
    /** When true, skips flex-fill styles. Use when wrapping drag-and-drop cards or
     *  block-level items where filling available space would break layout. */
    noFill?: boolean;
    className?: string;
    children: React.ReactNode;
}

export const AnimatedItem: React.FC<AnimatedItemProps> = ({ delay = 0, noFill = false, className, children }) => {
    const classes = useStyles();
    const layoutClass = noFill ? '' : ` ${classes.fill}`;
    const extraClass = className ? ` ${className}` : '';
    return (
        <div className={`${classes.root}${layoutClass}${extraClass}`} style={{ animationDelay: `${delay}ms` }}>
            {children}
        </div>
    );
};
